import { createSlice } from "@reduxjs/toolkit";

const productsSlice = createSlice({
  name: "products",
  initialState: [],
  reducers: {
    storeProducts(state, action) {
      const products = action.payload;

      if (products?.length > 0) {
        products.map((product) => {
          let existingItem = state.find((item) => item.id === product.id);
          if (!existingItem) {
            state.push(product);
          }
        });
      }
    },
  },
});

export const { storeProducts } = productsSlice.actions;

export default productsSlice.reducer;

export const productsItems = (state) => state.products;
